import styled from 'styled-components'

import { isIPad } from 'utils/device'

import { tabDesktopBreakpoint } from './constants'

export const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

export const QuizViewWrapper = styled.div`
    width: 100%;
    height: 100%;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 72.01vw;
        height: 88%;
        position: absolute;
        top: 9.7vh;
        left: 1.66vw;
    }
`
